import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setQidCompanyDocumentList = (
    documentList: types.QidCompanyDocumentList,
    documentIds: number[],
) => ({
    type: inferLiteral(types.QID_COMPANY_DOCUMENT_LIST),
    documentList,
    documentIds,
})
export const setQidCompanyDocumentReloadList = (value: boolean) => ({
    type: inferLiteral(types.QID_COMPANY_DOCUMENT_RELOAD_LIST),
    value,
})
